import React, { useState } from 'react';
// import Payment from './Payment'; // Adjust the import path as needed
import Payment from '../../Payment/payment'
import RevenueReport from './RevenueReport'; // Adjust the import path as needed

const PaymentOrReportSelector = () => {
  const [selectedOption, setSelectedOption] = useState('tour'); // Default to 'tour'

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      <div style={{ marginBottom: '20px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <label style={{ marginRight: '15px', fontWeight: 'bold' }}>
          Select Service Type:
        </label>
        <select
          value={selectedOption}
          onChange={handleOptionChange}
          style={{
            padding: '8px 12px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            fontSize: '16px'
          }}
        >
          <option value="tour">Tour/Auto</option>
          <option value="ticket">Ticket</option>
        </select>
      </div>

      {selectedOption === 'tour' ? <Payment /> : <RevenueReport />}
    </div>
  );
};

export default PaymentOrReportSelector;